// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___21wMv","icon":"styles__icon___10k6U","title":"styles__title___2FXfk"};